import { NavLink as MantineNavLink, UnstyledButton, rem } from '@mantine/core';
import { NavLink, useMatch } from 'react-router-dom';

import classes from './Navbar.module.css';

export function NavbarSubItem({
    icon: Icon,
    label,
    to,
    pattern,
    parentActive,
    onClick,
    exact = false,
}) {
    const active = useMatch(pattern || to || '', { exact });
    return (
        <NavLink to={to}>
            <MantineNavLink
                className={classes.link}
                h={26}
                py={'xs'}
                active={active}
                component={UnstyledButton}
                label={label}
                bg={!active && parentActive ? 'gray' : undefined}
                leftSection={
                    Icon ? (
                        <Icon
                            style={{ width: rem(20), height: rem(20) }}
                            stroke={1.5}
                        />
                    ) : null
                }
            />
        </NavLink>
    );
}
